import {Component, OnInit} from '@angular/core';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';
import {LoaderService, CreditNoteService} from '@app/shared/services';
import {CommonModule, DatePipe} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import { ModalDismissReasons,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import {environment} from '@env/environment';
import {NgxPrintDirective} from 'ngx-print';

@Component({
  selector: 'app-credit-note-list',
  templateUrl: './credit-note-list.component.html',
  styleUrls: ['./credit-note-list.component.scss'],
    imports: [
        PageHeaderComponent,
        SelectDropDownModule,
        FormsModule,
        CommonModule,
        RouterLink,
        NgxPrintDirective,
    ],
  providers: [DatePipe]
})

export class CreditNoteListComponent implements OnInit {
    user_rights: any;
    user_data: any;
    credit_note_list: any = [];
    searchFailed = false;
    searching = false;
    closeResult = "";
    crd_notes : any;
    env = environment;
    search_crd_note = '';
    start = 0;
    limit = 50;

    public institution = JSON.parse(localStorage.getItem('institution') || "{}");
    public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");

    constructor(
      private loaderService: LoaderService,
      private creditNoteService: CreditNoteService,
      protected utils: UtilsInjectable,
      private toastr: ToastrService,
      private modalService: NgbModal,
    ) {}

    ngOnInit() {
      this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
      this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
      this.getCreditNoteList();
    }

    public getCreditNoteList(page = 0) {
      this.start = page * this.limit;
      const postData = {
        start: this.start,
        limit: this.limit,
        search_text: this.search_crd_note 
      };
        this.loaderService.display(true);
        this.creditNoteService.getCreditNoteList(postData).subscribe((result: any) => {
            if (result['status'] == 'Success') {
                this.credit_note_list = result['data'];
            }else{
              this.credit_note_list = [];
            }
            this.loaderService.display(false);
        });
    }

    protected open(content: any) {
      this.modalService.open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'a4-page',
        windowClass: "custom"
      }).result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

    private getDismissReason(reason: any): string {
      if (reason == ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }

    deleteCreditNote(id: any){
        const confirmed = confirm('Are you sure you want to delete this Credit Note?');

        if (!confirmed) {
          return;
        }
        
        this.loaderService.display(true);
        this.creditNoteService.deleteCreditNote({crn_id : id}).subscribe((result: any) => {
            if (result['status'] == 'Success') {
                this.toastr.success(result['msg']);
            }else{
               this.toastr.error(result['msg']);
            }
            this.getCreditNoteList();
            this.loaderService.display(false);
        });
    }

    public getCreditNoteData(id :any){
      this.loaderService.display(true);
      this.creditNoteService.getCreditNote({crdn_id : id}).subscribe((result: any) => {
         this.crd_notes = result["data"];
         this.loaderService.display(false);
      });
    }

    getGrossTotal(): number {
      if (!this.crd_notes || this.crd_notes.length === 0) return 0;
      return this.crd_notes.reduce((sum :any, item :any) => sum + Number(item.CND_RETURN_TOTAL || 0), 0);
    }

    public keyDownFunction(event: any) {
      if (event.keyCode == 13) {
        this.getCreditNoteList();
      }
    }

    public clear_search() {
      if (this.search_crd_note != '') {
        this.search_crd_note = '';
        this.getCreditNoteList();
      }
    }

}
